<div class="flex flex-col w-full" [ngClass]="{ 'overflow-hidden': updatingTask}">
  <div class="flex items-center justify-between w-full mx-auto px-6 pt-6">
    <div class="flex items-center gap-2 text-xl md:text-2xl font-bold">
      <button mat-icon-button (click)="discard()">
        <mat-icon class="text-current" [svgIcon]="'mat_outline:arrow_back'"></mat-icon>
      </button>
      {{ service?.name }} - {{ task?.taskTypeName }} - {{ task?.taskId }}
    </div>

    <button mat-icon-button [matTooltip]="'close' | transloco" (click)="discard()">
      <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
    </button>
  </div>

  <form class="flex flex-col sm:flex-row w-full p-8" [formGroup]="taskForm">
    <div class="flex flex-col w-1/2 sm:pl-8">
      <!-- WITHOUT_TIME -->
      @if (task?.taskTypeTypology !== 'WITH_TIME') {
        <div *ngTemplateOutlet="withoutTime; context: { form: taskForm }"></div>
      }
      <!-- WITH_TIME -->
      @if (task?.taskTypeTypology === 'WITH_TIME') {
        <div *ngTemplateOutlet="withTime; context: { form: taskForm }"></div>
      }
    </div>

    <div class="flex flex-col w-1/2 sm:pl-8">
      <!-- TASKTYPE -->
      @if (taskTypeOptions?.length > 0) {
        <h2 class="pb-2 font-bold">{{ 'beautify.tasktype' | transloco }}</h2>
        <mat-form-field class="w-full pl-2">
          <mat-label>{{ 'beautify.tasktype' | transloco }}</mat-label>
          <mat-select formControlName="taskTypeId">
            @for (tasktype of taskTypeOptions; track tasktype) {
              <mat-option [value]="tasktype.code">
                {{ tasktype.value | localize }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (!service?.generateUsernamesManually) {
        <h2 class="pb-2 font-bold">{{ 'beautify.user' | transloco }}</h2>
        <!-- Zombies -->
        <mat-form-field class="w-full pl-2">
          <mat-label>{{ 'resource' | transloco }}</mat-label>
          <mat-select formControlName="zombie">
            @for (zombie of userZombiesCalendar.zombies; track zombie) {
              <mat-option [value]="zombie.zombieNumber">
                {{ zombie.name | localize }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }

      @if (task.addressUri) {
        <h2 class="pb-2 font-bold">{{ 'beautify.address' | transloco }}</h2>
        <!-- Address (si hay maestro de ubicaciones) -->
        <mat-form-field class="w-full pl-2">
          <mat-label>
            {{ 'place' | transloco }}
          </mat-label>
          <input matInput formControlName="address" [matAutocomplete]="ac">
          <mat-autocomplete autoActiveFirstOption #ac="matAutocomplete" [displayWith]="displayAddress">
            @if (addressOptions?.length === 0) {
              <mat-option disabled>
                {{ 'addressNotFound' | transloco }}
              </mat-option>
            }
            @for (option of addressOptions; track option) {
              <mat-option [value]="option">
                {{ option.name }}
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      }

      <!-- ExternalTaskId -->
      <h2 class="pb-2 font-bold">{{ 'beautify.task' | transloco }}</h2>
      <mat-form-field class="w-full pl-2">
        <mat-label>{{ 'externalTaskCode' | transloco }}</mat-label>
        <input matInput formControlName="externalTaskId">
      </mat-form-field>
    </div>
  </form>
  <div class="flex pb-8 px-8 justify-end">
    @if (flashMessage) {
      <div class="flex items-center mr-4">
        @if (flashMessage === 'success') {
          <mat-icon class="text-green-500" [svgIcon]="'heroicons_outline:check'"></mat-icon>
          <span class="ml-2">{{ 'taskUpdated' | transloco }}</span>
        }
        @if (flashMessage === 'error') {
          <mat-icon class="text-red-500" [svgIcon]="'heroicons_outline:x'"></mat-icon>
          <span class="ml-2">{{ 'errorDialogMsg' | transloco }}</span>
        }
      </div>
    }
    <button mat-flat-button [color]="'primary'" [disabled]="disableButton" (click)="beautifyTask()">
      {{ 'beautify.beautifyTask' | transloco }}
    </button>
  </div>
</div>

<ng-template #withoutTime  let-form="form">
  <div [formGroup]="form">
    <!-- Planning -->
    @if (!task.parentTaskId) {
      <h2 class="pb-2 font-bold">{{ 'beautify.planning' | transloco }}</h2>
      <div class="flex flex-col 3xl:flex-row pl-2 pb-4 3xl:pb-0">
        <mat-form-field class="w-full xl:w-2/3 3xl:w-1/2">
          <mat-label>{{ 'beautify.plannedStartDate' | transloco }}</mat-label>
          <input readonly matInput formControlName="scheduled_from_date"
            [matDatepicker]="datepickerPFrom"
            (click)="openDatepickerOnClick(datepickerPFrom)">
            <mat-datepicker-toggle matSuffix [for]="datepickerPFrom"></mat-datepicker-toggle>
            <mat-datepicker #datepickerPFrom></mat-datepicker>
          </mat-form-field>
          <div class="flex flex-col w-full xl:w-2/3 3xl:w-1/3 items-center">
            <mat-label class="font-medium mb-2 text-center">
              {{ 'beautify.plannedStartHour' | transloco }}
            </mat-label>
            <timepicker-autofill-component [control]="taskForm.get('scheduled_from_time')"
              [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
            </timepicker-autofill-component>
          </div>
        </div>
        <div class="flex flex-col 3xl:flex-row pl-2 pb-4 3xl:pb-0">
          <mat-form-field class="w-full xl:w-2/3 3xl:w-1/2">
            <mat-label>{{ 'beautify.plannedEndDate' | transloco }}</mat-label>
            <input readonly matInput formControlName="scheduled_to_date"
              [matDatepicker]="datepickerPTo"
              (click)="openDatepickerOnClick(datepickerPTo)">
              <mat-datepicker-toggle matSuffix [for]="datepickerPTo"></mat-datepicker-toggle>
              <mat-datepicker #datepickerPTo></mat-datepicker>
            </mat-form-field>
            <div class="flex flex-col w-full xl:w-2/3 3xl:w-1/3 items-center">
              <mat-label class="font-medium mb-2 text-center">
                {{ 'beautify.plannedEndHour' | transloco }}
              </mat-label>
              <timepicker-autofill-component [control]="taskForm.get('scheduled_to_time')"
                [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
              </timepicker-autofill-component>
            </div>
          </div>
        }
        <!-- Execution -->
        @if (task.taskTypeTypology !== 'TASK_ASSIGNMENT') {
          <h2 class="pb-2 font-bold">{{ 'beautify.execution' | transloco }}</h2>
          <!-- Start Date -->
          <div class="flex flex-col 3xl:flex-row pl-2 pb-4 3xl:pb-0">
            <mat-form-field class="w-full xl:w-2/3 3xl:w-1/2">
              <mat-label>{{ 'beautify.startDate' | transloco }}</mat-label>
              <input readonly matInput formControlName="startDate"
                [matDatepicker]="datepickerFrom"
                (click)="openDatepickerOnClick(datepickerFrom)"
                [placeholder]="'startDatePlaceholder' | transloco">
                <mat-datepicker-toggle matSuffix [for]="datepickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #datepickerFrom></mat-datepicker>
              </mat-form-field>
              <!-- Start Time -->
              <div class="flex flex-col w-full xl:w-2/3 3xl:w-1/3 items-center">
                <mat-label class="font-medium mb-2 text-center">
                  {{ 'beautify.startHour' | transloco }}
                </mat-label>
                <timepicker-autofill-component [control]="taskForm.get('startTime')"
                  [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
                </timepicker-autofill-component>
              </div>
            </div>
            <!-- End Date -->
            <div class="flex flex-col 3xl:flex-row pl-2 pb-4 3xl:pb-0">
              <mat-form-field class="w-full xl:w-2/3 3xl:w-1/2">
                <mat-label>{{ 'beautify.endDate' | transloco }}</mat-label>
                <input readonly matInput formControlName="endDate"
                  [matDatepicker]="datepickerTo"
                  (click)="openDatepickerOnClick(datepickerTo)"
                  [placeholder]="'endDatePlaceholder' | transloco">
                  <mat-datepicker-toggle matSuffix [for]="datepickerTo"></mat-datepicker-toggle>
                  <mat-datepicker #datepickerTo></mat-datepicker>
                </mat-form-field>
                <!-- End Time -->
                <div class="flex flex-col w-full xl:w-2/3 3xl:w-1/3 items-center">
                  <mat-label class="font-medium mb-2 text-center">
                    {{ 'beautify.endHour' | transloco }}
                  </mat-label>
                  <timepicker-autofill-component [control]="taskForm.get('endTime')"
                    [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
                  </timepicker-autofill-component>
                </div>
              </div>
            }
          </div>
        </ng-template>

        <ng-template #withTime let-form="form">
          <div [formGroup]="form">
            <!-- Planning -->
            @if (!task.parentTaskId) {
              <h2 class="pb-2 font-bold">{{ 'beautify.planning' | transloco }}</h2>
              <div class="flex pl-2">
                @if (workdayTypeOptions?.length > 0) {
                  <mat-form-field class="w-full">
                    <mat-label>{{ 'workDay' | transloco }}</mat-label>
                    <mat-select formControlName="workDayTypeOid">
                      <mat-option [value]="">
                        {{ 'noSelection' | transloco }}
                      </mat-option>
                      @for (workday of workdayTypeOptions; track workday) {
                        <mat-option [value]="workday.code">
                          {{ workday.value | localize }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </div>
              <div class="flex pl-2">
                <mat-form-field class="w-full">
                  <mat-label>{{ 'beautify.plannedStartDate' | transloco }}</mat-label>
                  <input readonly matInput formControlName="scheduled_from_date"
                    [matDatepicker]="datepickerPFrom"
                    (click)="openDatepickerOnClick(datepickerPFrom)">
                    <mat-datepicker-toggle matSuffix [for]="datepickerPFrom"></mat-datepicker-toggle>
                    <mat-datepicker #datepickerPFrom></mat-datepicker>
                  </mat-form-field>
                </div>
                <!-- Horas según el tipo de jornada -->
                <!-- Tipo distinto de SPLIT -->
                @if (task?.workDayTypeMode !== 'SPLIT') {
                  <div *ngTemplateOutlet="generalTimes; context: { planning: true }"></div>
                }
                <!-- Tipo SPLIT -->
                @if (task?.workDayTypeMode === 'SPLIT') {
                  <div *ngTemplateOutlet="splitTimes; context: { planning: true }"></div>
                }
              }

              <!-- Execution -->
              <h2 class="pb-2 font-bold">{{ 'beautify.execution' | transloco }}</h2>
              <!-- Start Date -->
              <div class="flex pl-2">
                <mat-form-field class="w-full">
                  <mat-label>{{ 'beautify.startDate' | transloco }}</mat-label>
                  <input readonly matInput formControlName="startDate"
                    [matDatepicker]="datepicker"
                    (click)="openDatepickerOnClick(datepicker)"
                    [placeholder]="'startDatePlaceholder' | transloco">
                    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                    <mat-datepicker #datepicker></mat-datepicker>
                  </mat-form-field>
                </div>

                <!-- Horas según el tipo de jornada -->
                <!-- Tipo distinto de SPLIT -->
                @if (task?.workDayTypeMode !== 'SPLIT') {
                  <div *ngTemplateOutlet="generalTimes; context: { planning: false }"></div>
                }

                <!-- Tipo SPLIT -->
                @if (task?.workDayTypeMode === 'SPLIT') {
                  <div *ngTemplateOutlet="splitTimes; context: { planning: false }"></div>
                }

              </div>
            </ng-template>

            <ng-template #generalTimes let-planning="planning">
              <div class="flex flex-col xl:flex-row">
                <!-- Start Time -->
                <div class="mb-4 flex flex-col w-full items-center">
                  <mat-label class="font-medium mb-1">
                    {{ (planning ? 'beautify.plannedStartHour' : 'beautify.startHour') | transloco }}
                  </mat-label>
                  <timepicker-autofill-component [control]="taskForm.get(planning ? 'scheduled_from_time' : 'startTime')"
                    [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
                  </timepicker-autofill-component>
                </div>
                <!-- End Time -->
                <div class="mb-4 flex flex-col w-full items-center">
                  <mat-label class="font-medium mb-1">
                    {{ (planning ? 'beautify.plannedEndHour' : 'beautify.endHour') | transloco }}
                  </mat-label>
                  <timepicker-autofill-component [control]="taskForm.get(planning ? 'scheduled_to_time' : 'endTime')"
                    [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
                  </timepicker-autofill-component>
                </div>
              </div>
            </ng-template>


            <ng-template #splitTimes let-planning="planning">
              <div class="flex flex-col xl:flex-row">
                <!-- Start Time -->
                <div class="mb-2 flex flex-col w-full items-center">
                  <mat-label class="font-medium mb-1">
                    {{ (planning ? 'beautify.plannedStartHour' : 'beautify.startHour') | transloco }} (1)
                  </mat-label>
                  <timepicker-autofill-component [control]="taskForm.get(planning ? 'scheduled_from_time' : 'startTime')"
                    [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
                  </timepicker-autofill-component>
                </div>
                <!-- End Time -->
                <div class="mb-2 flex flex-col w-full items-center">
                  <mat-label class="font-medium mb-1">
                    {{ (planning ? 'beautify.plannedEndHour' : 'beautify.endHour') | transloco }} (1)
                  </mat-label>
                  <timepicker-autofill-component [control]="taskForm.get(planning ? 'scheduled_to_time' : 'endTime')"
                    [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
                  </timepicker-autofill-component>
                </div>
              </div>
              <div class="flex flex-col xl:flex-row">
                <!-- Start Time2 -->
                <div class="mb-4 flex flex-col w-full items-center">
                  <mat-label class="font-medium mb-1">
                    {{ (planning ? 'beautify.plannedStartHour' : 'beautify.startHour') | transloco }} (2)
                  </mat-label>
                  <timepicker-autofill-component [control]="taskForm.get(planning ? 'scheduled_from_time2' : 'startTime2')"
                    [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
                  </timepicker-autofill-component>
                </div>
                <!-- End Time2 -->
                <div class="mb-4 flex flex-col w-full items-center">
                  <mat-label class="font-medium mb-1">
                    {{ (planning ? 'beautify.plannedEndHour' : 'beautify.endHour') | transloco }} (2)
                  </mat-label>
                  <timepicker-autofill-component [control]="taskForm.get(planning ? 'scheduled_to_time2' : 'endTime2')"
                    [allowManual]="true" [minuteStep]="15" [style]="'HH:mm'" [spinners]="false">
                  </timepicker-autofill-component>
                </div>
              </div>
            </ng-template>